/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Username_LabelInputs */

const en_onboarding_v1_username_label = /** @type {(inputs: Onboarding_V1_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Username`)
};

const de_onboarding_v1_username_label = /** @type {(inputs: Onboarding_V1_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzername`)
};

const pt_br2_onboarding_v1_username_label = /** @type {(inputs: Onboarding_V1_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome de usuário`)
};

const tr_onboarding_v1_username_label = /** @type {(inputs: Onboarding_V1_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanıcı adı`)
};

const zh_cn2_onboarding_v1_username_label = /** @type {(inputs: Onboarding_V1_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户名`)
};

const zh_hk2_onboarding_v1_username_label = /** @type {(inputs: Onboarding_V1_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用戶名稱`)
};

const ko_kr2_onboarding_v1_username_label = /** @type {(inputs: Onboarding_V1_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용자 이름`)
};

const ru_ru2_onboarding_v1_username_label = /** @type {(inputs: Onboarding_V1_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя пользователя`)
};

const es_419_onboarding_v1_username_label = /** @type {(inputs: Onboarding_V1_Username_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de usuario`)
};

/**
* | output |
* | --- |
* | "Username" |
*
* @param {Onboarding_V1_Username_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_username_label = /** @type {((inputs?: Onboarding_V1_Username_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Username_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_username_label(inputs)
	if (locale === "de") return de_onboarding_v1_username_label(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_username_label(inputs)
	if (locale === "tr") return tr_onboarding_v1_username_label(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_username_label(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_username_label(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_username_label(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_username_label(inputs)
	return es_419_onboarding_v1_username_label(inputs)
});